import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { ReactTitle } from "react-meta-tags";
import { withTranslation } from "react-i18next";
import { getRoles } from "../../../Redux/reducer/session";
import { moduleAction, loadingHtml } from "../../utils/functions";
import * as ProviderActions from "../../../Redux/actions/providerActions";
import {
  getProviders,
  getTotalElements,
} from "../../../Redux/reducer/providers";
import MainTemplate from "../mainTemplate";
import Modal from "../../utils/customModal";
import BlankProvider from "../provider/blankprovider";
import ProviderTable from "../tableProvider/table-provider";
import ProviderAditionalModify from "../tableProvider/table-provider-additional-modify";
import Tabs from "../../public/tableProvider/tabs";
import { MOD_PROVID, WRITE, EXECUTE } from "../../../permissions";
import "../../../../resources/components/public/provider/customBottomTab.css";
import IconSettings from "canvas-core-react/lib/IconSettings";
import IconAddOutline from "canvas-core-react/lib/IconAddOutline";
import FilterComponentProvider from "../../utils/filterComponentProvider";
import TermExtension from "./TermExtension";

export class Provider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
      componentReady: false,
      page: 1,
      data: null,
      totalSize: 0,
      sizePerPage: 10,
      searchFilters: false,
      firstLoad: false,
      termExtensionRow: null,
    };
  }

  componentDidMount() {
    // Cargamos los proveedores
    const {
      actions: { getProvidersList },
    } = this.props;

    return getProvidersList().then(() => {
      this.setState({ modal: false, componentReady: true, firstLoad: true });
    });
  }

  componentWillUnmount() {
    // Limpiamos la carga de proveedores
    this.props.actions.clearProvidersList();
  }

  search = (searchProperty, serachTerm) => {
    const {
      actions: { getSearchContent, getProvidersList },
    } = this.props;
    if (serachTerm == "") {
      getProvidersList();
      this.setState({ searchFilters: false });
    } else {
      var operator = "";
      var filters = this.getFilters();
      filters.map((item) => {
        if (item.property == searchProperty) {
          operator = item.operator;
        }
      });

      var actionFilters = [
        { property: searchProperty, operator: operator, value: serachTerm },
      ];

      getSearchContent(actionFilters);
      this.setState({ searchFilters: true });
    }
  };

  getFilters() {
    const { t } = this.props;
    return [
      {
        name: `${t("general.filters.name")}`,
        property: "provider.institution.name",
        operator: "eq",
      },
      {
        name: `${t("general.filters.identification")}`,
        property: "provider.institution.businessId",
        operator: "eq",
      },
    ];
  }

  handleTermExtensionRow = (data) => {
    this.setState({ termExtensionRow: data });
  };

  providerTable = () => {
    const { searchFilters, page, sizePerPage, firstLoad } = this.state;
    const { proveedores, totalElements, roles, t, history } = this.props;

    const filters = this.getFilters();

    const writePermissions = moduleAction(roles, MOD_PROVID, WRITE);
    const addPermissions =
      writePermissions || moduleAction(roles, MOD_PROVID, EXECUTE);

    const customClass = addPermissions ? "" : "justify-content-end";

    if (
      searchFilters ||
      (firstLoad === true && proveedores !== null && proveedores.length > 0)
    ) {
      return (
        <React.Fragment>
          {!this.state.termExtensionRow ? (
            <Tabs>
              <div label={t("providers.title")}>
                <div className={`flex-element left-flex ${customClass}`}>
                  {addPermissions && (
                    <Link
                      to="/providers/configurations"
                      className="d-flex align-items-center left-flex add-button mr-4"
                    >
                      <p className="bsc-add-client">Configuraciones</p>
                      <IconSettings />
                    </Link>
                  )}

                  {writePermissions && (
                    <Link
                      to="/providers/add"
                      className="d-flex align-items-center add-button mr-4"
                    >
                      <p className="bsc-add-client">{t(`providers.addLbl`)}</p>
                      <IconAddOutline />
                    </Link>
                  )}
                  <FilterComponentProvider
                    filter={filters}
                    searchFnc={this.search}
                  />
                </div>
                <ProviderTable
                  data={proveedores}
                  history={history}
                  page={page}
                  getProvidersList={this.props.actions.getProvidersList}
                  totalSize={totalElements}
                  sizePerPage={sizePerPage}
                  handleTermExtensionRow={this.handleTermExtensionRow}
                />
              </div>

              <div label={t("providers.additionsTab")}>
                <ProviderAditionalModify />
              </div>
            </Tabs>
          ) : (
            <TermExtension
              handleBack={() => this.handleTermExtensionRow(null)}
              {...this.state.termExtensionRow}
            />
          )}
        </React.Fragment>
      );
    } else return <BlankProvider />;
  };

  loadProviders() {
    const { searchFilters, firstLoad } = this.state;
    const { proveedores } = this.props;

    return searchFilters ? (
      this.providerTable()
    ) : firstLoad || (proveedores !== null && proveedores.length > 0) ? (
      this.providerTable()
    ) : (
      <BlankProvider />
    );
  }

  render() {
    const { t } = this.props;

    return (
      <MainTemplate>
        <ReactTitle title={`${t("providers.meta.title")} - ${t("appName")}`} />
        {this.state.componentReady ? this.loadProviders() : null}
        <Modal show={this.state.modal}>{loadingHtml()}</Modal>
      </MainTemplate>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    roles: getRoles(state),
    proveedores: getProviders(state),
    totalElements: getTotalElements(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(ProviderActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatch
)(withTranslation()(Provider));
